import React from 'react'
import { NavLink } from 'react-router-dom'
import { Routes } from 'common/routeConfig'
import { useHeaderStyles } from './Header.styles'

const AppLogo: React.FC = () => {
    const styles = useHeaderStyles()

    return (
        <NavLink to={Routes.BASE}>
            <div className={styles.appLogoContainer}>
                <div className={styles.logo}>
                    <img
                        className={styles.image}
                        src="assets/icons/genomate-logo-white.webp"
                        alt="App Logo"
                    />
                </div>
            </div>
        </NavLink>
    )
}

const Header: React.FC = () => {
    const styles = useHeaderStyles()

    return (
        <header className={styles.header} id="header">
            <AppLogo />
        </header>
    )
}

export default Header
